import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, ProgressBar} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../../utilities/Validator";

const timer = require('react-native-timer');


export default class LokalizacjaSzukajContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            kurs: '',
            kierowca: null,
            pojazd: null,
            czyOdswiezanie: false,
            timerOdswiezania: 60,
            czasOdswiezania: 60
        };
        this.onClickWyszukaj = this.onClickWyszukaj.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeKurs = this.onChangeKurs.bind(this)
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onChangePojazd = this.onChangePojazd.bind(this)
        this.onClickOdswiezanie = this.onClickOdswiezanie.bind(this)
        this.onchangeCzasOdswiezania = this.onchangeCzasOdswiezania.bind(this)
        this.timer = this.timer.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.przekazaneIdKursu)) {
            this.setState({kurs: this.props.przekazaneIdKursu})
            document.getElementById('inputIdKursu').value = this.props.przekazaneIdKursu
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.przekazaneIdKursu)) {
            this.setState({kurs: nextprops.przekazaneIdKursu})
            document.getElementById('inputIdKursu').value = nextprops.przekazaneIdKursu
        }
    }


    onClickWyszukaj() {

        timer.clearInterval('zliczanieOdswiezenia')
        this.setState({czyOdswiezanie: false})

        if (!Boolean(this.state.trasa) &&
            !Boolean(this.state.kurs) &&
            !Boolean(this.state.kierowca) &&
            !Boolean(this.state.pojazd)
        ) {
            alert('Należy uzupełnić co najmniej jedno pole!')
        } else {

            let params = {
                trasa: Boolean(this.state.trasa) ? this.state.trasa.idTr : null,
                kierowca: Boolean(this.state.kierowca) ? this.state.kierowca.idKi : null,
                pojazd: Boolean(this.state.pojazd) ? this.state.pojazd.idPo : null,
                kurs: this.state.kurs
            }

            this.props.handleClickWyszukaj(params)

        }
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeKurs(e) {
        this.setState({kurs: e.target.value})
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
    }

    onChangePojazd(e) {
        this.setState({pojazd: e})
    }


    onClickOdswiezanie() {
        this.setState({czyOdswiezanie: !this.state.czyOdswiezanie})
        timer.clearInterval('zliczanieOdswiezenia')
        if (this.state.czyOdswiezanie === true) {
        }
        else {
            this.setInterval()
        }
    }

    onchangeCzasOdswiezania(e) {
        this.setState({czasOdswiezania: e.target.value, timerOdswiezania: e.target.value})
        timer.clearInterval('zliczanieOdswiezenia')

        if (e !== null && this.state.czyOdswiezanie) {
            if (e.target.value !== '')
                this.setInterval(e.target.value)
        }
        if (!Validator.validateInt(e.target.value)) {
            alert('Czas odswieżania musi być liczbą całkowitą dodatnią!')
            timer.clearInterval('zliczanieOdswiezenia')
            this.setState({czyOdswiezanie: false})
        }
    }

    timer() {
        this.setState({
            timerOdswiezania: this.state.timerOdswiezania - 1
        })
        if (this.state.timerOdswiezania < 1) {
            this.setState({timerOdswiezania: this.state.czasOdswiezania})
            this.props.handleOdswiezDane()
        }

    }

    setInterval() {
        timer.setInterval('zliczanieOdswiezenia', this.timer.bind(this), 1000);
    }

    formatTrasaSelect(option) {
        return <div>
            <span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                  wartosc={option.status}
                                                                                                                  czyMarginesLewy={true}/>
        </div>
    }

    renderKierowca(option) {
        return <div>
            <span>{option.imieNazwisko} <TopDostepnosc wartoscWarunek={1}
                                                       wartosc={option.status}
                                                       czyMarginesLewy={true}
                                                       trescSpelniony={'aktywny'}
                                                       trescNiespelniony={'nieaktywny'}
            /></span>
            {
                Boolean(option.nrTel) ?
                    Boolean(option.nrTel.length > 5) ?
                        <div className={'pull-right'}>
                            <span style={{color: 'grey', fontSize: '14px'}}><i className={'fa fa-phone'}></i> {option.nrTel}</span>
                        </div>
                        :
                        ''
                    :
                    ''
            }
        </div>
    }

    renderPojazd(option) {
        return (<div>
            <span>{option.pojazd} <span style={{fontWeight: 'bold'}}>{option.nrRej}</span> <TopDostepnosc wartoscWarunek={1}
                                                                                                          wartosc={option.status}
                                                                                                          czyMarginesLewy={true}
                                                                                                          trescSpelniony={'aktywny'}
                                                                                                          trescNiespelniony={'nieaktywny'}
            /></span>
        </div>)
    }


    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col sm={3}>
                            <ControlLabel>
                                Trasa
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                       valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}
                                       valueKey={'idTr'} labelKey={'nazTr'}
                            />
                        </Col>
                        <Col sm={1}>
                            <ControlLabel>
                                Kurs
                            </ControlLabel>
                            <FormControl type={'number'} onChange={this.onChangeKurs} id={'inputIdKursu'}/>
                        </Col>
                        <Col sm={3}>
                            <ControlLabel>
                                Kierowca
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeKierowca} value={this.state.kierowca} options={this.props.kierowcy}
                                       valueKey={'idKi'} labelKey={'imieNazwisko'} valueRenderer={this.renderKierowca}
                                       optionRenderer={this.renderKierowca}
                            />
                        </Col>
                        <Col sm={3}>
                            <ControlLabel>
                                Pojazd
                            </ControlLabel>
                            <TopSelect onChange={this.onChangePojazd} value={this.state.pojazd} options={this.props.pojazdy}
                                       valueKey={'idPo'} labelKey={'pojazdLabel'} valueRenderer={this.renderPojazd} optionRenderer={this.renderPojazd}
                            />
                        </Col>
                        <Col sm={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction
                                onClick={this.onClickWyszukaj}
                                iconType={'fa fa-search'}
                                btnColor={'primary'}
                                text={'Znajdź busy'}
                                btnSize={'md'}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col sm={4}>
                            <div style={{marginTop: '15px'}}>
                                <ControlLabel style={{fontWeight: 'normal'}}>Odświeżaj co</ControlLabel>
                                <input defaultValue={'60'} type={'number'}
                                       min={1} max={999999} className={'form-control'} onChange={this.onchangeCzasOdswiezania}
                                       style={{display: 'inline', width: '80px', margin: '0 3px'}}/>
                                <ControlLabel style={{marginRight: '25px', fontWeight: 'normal'}}>sekund</ControlLabel>
                                {
                                    Boolean(this.state.czyOdswiezanie) ?
                                        <TopButtonAction btnSize={'md'} btnColor={'warning'} iconType={'fa fa-power-off'} text={'Dezaktywuj'}
                                                         onClick={this.onClickOdswiezanie}/>
                                        :
                                        <TopButtonAction btnSize={'md'} btnColor={'warning'} iconType={'fa fa-refresh'} text={'Zastosuj'}
                                                         onClick={this.onClickOdswiezanie}
                                                         btnDisabled={Boolean(this.state.czasOdswiezania) ? this.state.czasOdswiezania <= 0 : true}/>

                                }
                            </div>
                        </Col>
                        <Col sm={7}>
                            <TopIf isTrue={this.state.czyOdswiezanie}>
                                <div style={{marginTop: '20px'}}>
                                    <ProgressBar style={{marginBottom: '2px'}}>
                                        <ProgressBar bsStyle="warning" now={(this.state.timerOdswiezania * 100) / this.state.czasOdswiezania}
                                                     key={1}/>
                                    </ProgressBar>
                                    <div style={{textAlign: 'center', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>
                                        Odświeżenie nastąpi za {this.state.timerOdswiezania} sekund
                                    </div>
                                </div>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/lokalizacjaBusow/components/LokalizacjaSzukajContainer.js